export default __webpack_public_path__ + "static/media/blue-desktop-bg.f9085452.svg";